module.exports = __webpack_public_path__ + "static/media/Closed.bfeab106.svg";